export default "__VITE_ASSET__53IFkM1A__"